import { Profile, PreferenceDefinition } from '../../models/user';

export interface UserState extends Profile {
  preferenceOptions: PreferenceDefinition[];
}

import {
  LOAD_USER,
  EDIT_USER,
  SAVE_USER,
  EditUserActionPayload,
} from '../actions';
import createReducer from '../../lib/createReducer';

const initialState = {};

const handleUserData = (state: UserState, user: UserState): UserState => ({
  ...state,
  ...user,

  profile: {
    ...user.profile,

    gender: user.profile.gender || 'F',
  },
});

const handleChangeUserData = (
  state: UserState,
  { field, value }: EditUserActionPayload
): UserState => ({
  ...state,
  profile: {
    ...state.profile,
    [field]: value,
  },
});

const handlers = {
  [LOAD_USER + '_FULFILLED']: handleUserData,
  [SAVE_USER + '_FULFILLED']: handleUserData,
  [EDIT_USER]: handleChangeUserData,
};

export default createReducer(handlers, initialState);
